// lib/Image/config.ts
var e = { maxSizeInMb: 50 };
export { e as CONFIG };
